import I18n from 'ex-react-native-i18n';

I18n.fallbacks = true; // let 'en-GB' fallback to 'en' if not found
I18n.translations = {
	'de': require('../../config/i18n/de.json'),
	'en': require('../../config/i18n/en.json'),
}

export default I18n;